var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiobox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "white",
    stroke: "#D3D3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03419 14.2303C7.94055 14.2303 7.85039 14.2134 7.76371 14.1797C7.67649 14.1465 7.59944 14.0965 7.53256 14.0296L4.1817 10.6788C4.06131 10.5584 4.00432 10.4144 4.01074 10.247C4.0177 10.08 4.07468 9.93636 4.1817 9.81597C4.30209 9.69558 4.44602 9.63539 4.6135 9.63539C4.78044 9.63539 4.91741 9.69558 5.02443 9.81597L8.03419 12.8257L14.9767 5.88322C15.0837 5.76283 15.2242 5.70264 15.3981 5.70264C15.572 5.70264 15.7124 5.76283 15.8194 5.88322C15.9398 6.00361 16 6.14728 16 6.31422C16 6.4817 15.9398 6.62563 15.8194 6.74602L8.53581 14.0296C8.46893 14.0965 8.39215 14.1465 8.30547 14.1797C8.21825 14.2134 8.12782 14.2303 8.03419 14.2303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiobox);
export default __webpack_public_path__ + "static/media/Radio box.256ac9379006cc32b8bdeade1e84504d.svg";
export { ForwardRef as ReactComponent };